import {connect} from 'react-redux';
import Apper from '../components/Apper';
import {quantile} from 'd3-array';
import {hashHistory} from 'react-router';

const getYearPrices = (active_probability, samples) => {
  const year_prices = samples.map((year_samples) => {
    let price = Math.round(quantile(year_samples, active_probability));
    return price;
  })
  return year_prices;
}

const getYearProbabilities = (active_price, samples) => {
  const year_probabilities = samples.map((year_samples) => {
    let below_price_counter = 0;
    for (let sample of year_samples) {
      if (sample <= active_price) {
        below_price_counter++
      }
    }
    const probability = below_price_counter/year_samples.length;
    return probability;
  })
  return year_probabilities;
}

const getYearPricesAll = (samples) => {
  const year_prices = samples.map((year_samples) => {
    // TODO: for the graphs, this is repetitive but will work for now
    let bottom_price = Math.round(quantile(year_samples,0.25));
    let median_price = Math.round(quantile(year_samples,0.5));
    let top_price = Math.round(quantile(year_samples,0.75));
    return [bottom_price, median_price, top_price];
  })
  return year_prices;
}

const setNeighborhoodProperties = (active_year, active_probability, active_price, neighborhoods, neighborhoods_samples) => {
  let new_neighborhoods = neighborhoods.map((neighborhood, i) => {
    let active_neighborhoods_samples = neighborhoods_samples[active_year][i];
    let below_price_counter = 0;
    for (let sample of active_neighborhoods_samples) {
      if (sample <= active_price) {
        below_price_counter++
      }
    }
    let probability = below_price_counter/active_neighborhoods_samples.length;
    let price = Math.round(quantile(active_neighborhoods_samples, active_probability));
    neighborhood.properties.price = price;
    neighborhood.properties.probability = probability;
    return neighborhood
  })
  return new_neighborhoods
}

const setHexProperties = (active_year, active_probability, active_price, hex_arrays) => {
  let hexes = hex_arrays.hex_geojson.map((hex, i) => {
    let hex_samples = hex_arrays.hex_samples[active_year][i];
    let below_price_counter = 0;
    for (let sample of hex_samples) {
      if (sample <= active_price) {
        below_price_counter++
      }
    }
    let probability = below_price_counter/hex_samples.length;
    let price = Math.round(quantile(hex_samples, active_probability));
    hex.properties.price = price;
    hex.properties.probability = probability;
    return hex
  });
  return hexes;
}

const ApperContainer = connect(
  function mapStateToProps(full_state, ownProps) {

    let params = ownProps.params;

    let active_mode;
    if (params.mode == 'price') active_mode = 'Price';
    if (params.mode == 'probability') active_mode = 'Chance';

    let active_price, active_probability;
    if (params.mode == 'probability') {
      active_price = parseFloat(params.active_var.split('-')[0]);
      active_probability = parseFloat(params.active_var.split('-')[1]/100);
    } else {
      active_probability = parseFloat(params.active_var.split('-')[0]/100);
      active_price = parseFloat(params.active_var.split('-')[1]);
    }

    let active_year = parseFloat(params.year);

    let borough_filter;
    if (params.borough_filter == 'all_boroughs') {
      borough_filter = false;
    } else {
      borough_filter = ownProps.params.borough_filter;
    }

    const capitalize = (str) => str.replace(/\b\w/g, l => l.toUpperCase());

    let active_neighborhood;
    if (params.neighborhood == 'all_neighborhoods') {
      active_neighborhood = false;
    } else {
      active_neighborhood = capitalize(params.neighborhood.replace(/_/g,' '));
      if (active_neighborhood === 'Dumbo-Vinegar Hill-Downtown Brooklyn-Boerum Hill') active_neighborhood = 'DUMBO-Vinegar Hill-Downtown Brooklyn-Boerum Hill'
      if (active_neighborhood === 'Soho-Tribeca-Civic Center-Little Italy') active_neighborhood = 'SoHo-TriBeCa-Civic Center-Little Italy'
      if (active_neighborhood === 'Co-Op City') active_neighborhood = 'Co-op City'
    }

    let explainer;
    if (ownProps.query.explainer && ownProps.query.explainer.toLowerCase() === 'true') {
      explainer = true;
    } else {
      explainer = false;
    }

    let show_roads = true;
    if (ownProps.query.show_roads && ownProps.query.show_roads.toLowerCase() === 'false') {
      show_roads = false;
    }

    let active_hex = false;
    if (params.hex) active_hex = parseFloat(params.hex);

    const browser_width = full_state.browser.width;
    const {neighborhoods, neighborhoods_samples, map, price_focus, probability_focus, hex_arrays, mobile_toggle} = full_state.app;

    let new_neighborhoods = neighborhoods;
    if (neighborhoods_samples[active_year] !== undefined) {
      new_neighborhoods = setNeighborhoodProperties(active_year, active_probability, active_price, neighborhoods, neighborhoods_samples);
      if (active_mode === 'Chance') {
        new_neighborhoods.sort((a,b) => {
          if (a.properties.probability === b.properties.probability) {
            if (a.properties.neighborhood < b.properties.neighborhood)
              return -1;
            if (a.properties.neighborhood > b.properties.neighborhood)
              return 1;
            return 0;
          }
          if (a.properties.probability > b.properties.probability)
            return -1;
          if (a.properties.probability < b.properties.probability)
            return 1;
          return 0;
        })
      } else if (active_mode === 'Price') {
        new_neighborhoods.sort((a,b) => {
          if (a.properties.price > b.properties.price)
            return -1;
          if (a.properties.price < b.properties.price)
            return 1;
          return 0;
        })
      }
    }

    let hexes = false;
    let hex_samples = false;
    if (hex_arrays) {
      hexes = setHexProperties(active_year, active_probability, active_price, hex_arrays);
    }

    let active_neighborhood_with_samples = false;
    if (active_neighborhood) {
      let neighborhood_names = neighborhoods.map((neighborhood) => neighborhood.properties.neighborhood);
      let new_neighborhood_names = new_neighborhoods.map((neighborhood) => neighborhood.properties.neighborhood);
      let active_index = neighborhood_names.indexOf(active_neighborhood);
      let new_active_index = new_neighborhood_names.indexOf(active_neighborhood)
      active_neighborhood = new_neighborhoods[new_active_index]
      active_neighborhood_with_samples = Object.assign({}, active_neighborhood);
      let neighborhood_samples = [];
      Object.keys(neighborhoods_samples).forEach((key) => {
        neighborhood_samples.push(neighborhoods_samples[key][active_index])
      })
      const year_prices = getYearPrices(active_probability, neighborhood_samples);
      const year_all_prices = getYearPricesAll(neighborhood_samples);
      const year_probabilities = getYearProbabilities(active_price, neighborhood_samples);
      active_neighborhood_with_samples.samples = neighborhood_samples;
      active_neighborhood_with_samples.year_prices = year_prices;
      active_neighborhood_with_samples.year_all_prices = year_all_prices;
      active_neighborhood_with_samples.year_probabilities = year_probabilities;
    }

    let active_hex_with_samples = false;
    if (active_hex && hexes) {
      let hexids = hexes.map((hex) => hex.properties.hexid);
      let active_index = hexids.indexOf(active_hex);
      active_hex = hexes[active_index];
      let hex_samples_temp = hex_arrays.hex_samples;
      active_hex_with_samples = Object.assign({}, active_hex);
      let active_hex_samples = [];
      Object.keys(hex_samples_temp).forEach((key) => {
        active_hex_samples.push(hex_samples_temp[key][active_index])
      })
      const hex_year_prices = getYearPrices(active_probability, active_hex_samples);
      const hex_year_all_prices = getYearPricesAll(active_hex_samples);
      const hex_year_probabilities = getYearProbabilities(active_price, active_hex_samples);
      active_hex_with_samples.samples = active_hex_samples;
      active_hex_with_samples.year_prices = hex_year_prices;
      active_hex_with_samples.year_all_prices = hex_year_all_prices;
      active_hex_with_samples.year_probabilities = hex_year_probabilities;
    }

    const paramsToString = (params) => {
      let string = '/' + params.mode + '/' + params.active_var + '/' + params.year + '/' + params.borough_filter + '/' + params.neighborhood;
      if (params.hex) string = string + '/' + params.hex;
      return { pathname: string, query: ownProps.query };
    }

    const changeMobileShow = (value) => {
      let new_query = Object.assign(ownProps.query, {mobile_show: value})
      hashHistory.push({pathname: ownProps.path, query: new_query})
    }

    let mobile_show = false;
    // check for existing param first
    if (ownProps.query.mobile_show) {
      if (ownProps.query.mobile_show.toLowerCase() === 'info') {
        mobile_show = 'info';
      } else  {
        mobile_show = 'map';
      }
    }

    // if mobile and no existing param then try and select the best display mode
    if (browser_width < 451 && !mobile_show) {
      if (active_hex || active_neighborhood) {
        mobile_show = 'info';
      } else {
        mobile_show = 'map';
      }
    }

    const changeActiveMode = (mode) => {
      let mode_param;
      if (mode == 'Price') mode_param = 'price';
      if (mode == 'Chance') mode_param = 'probability'
      let new_active_var
      if (mode_param == 'probability') {
        new_active_var = active_price + '-' + (active_probability * 100)
      } else {
        new_active_var = (active_probability * 100) + '-' + active_price
      }
      let new_params = Object.assign(params, {mode: mode_param, active_var: new_active_var});
      const new_params_string = paramsToString(new_params)
      hashHistory.push(new_params_string);
    }

    const changeActivePrice = (price) => {
      let new_active_var
      let new_price = price
      if (params.mode == 'probability') {
        new_active_var = new_price + '-' + (active_probability * 100)
      } else {
        new_active_var = (active_probability * 100) + '-' + new_price
      }
      let new_params = Object.assign(params, {active_var: new_active_var});
      const new_params_string = paramsToString(new_params)
      hashHistory.push(new_params_string);
    }

    const changeActiveProbability = (probability) => {
      let new_active_var;
      let new_probability = probability * 100;
      if (params.mode == 'probability') {
        new_active_var = active_price + '-' + new_probability
      } else {
        new_active_var = new_probability + '-' + active_price
      }
      let new_params = Object.assign(params, {active_var: new_active_var});
      const new_params_string = paramsToString(new_params)
      hashHistory.push(new_params_string);
    }

    const changeActiveYear = (year) => {
      let new_params = Object.assign(params, {year: year});
      const new_params_string = paramsToString(new_params)
      hashHistory.push(new_params_string);
    }

    const setBoroughFilter = (borough) => {
      let new_borough = 'all_boroughs';
      if (borough) new_borough = borough;
      let new_params = Object.assign(params, {borough_filter: new_borough});
      const new_params_string = paramsToString(new_params)
      hashHistory.push(new_params_string);
    }

    const setExplainer = (value) => {
      if (value) {
        let new_query = Object.assign(ownProps.query, {explainer: true})
        hashHistory.push({pathname: ownProps.path, query: new_query})
      } else {
        let new_query = Object.assign({}, ownProps.query)
        delete new_query['explainer']
        hashHistory.push({pathname: ownProps.path, query: new_query})
      }
    }

    const setShowRoads = (value) => {
      if (!value) {
        let new_query = Object.assign(ownProps.query, {show_roads: false})
        hashHistory.push({pathname: ownProps.path, query: new_query})
      } else {
        let new_query = Object.assign({}, ownProps.query)
        delete new_query['show_roads']
        hashHistory.push({pathname: ownProps.path, query: new_query})
      }
    }

    const setActiveHex = (hex) => {
      let new_params = Object.assign(params, {hex: hex});
      const new_params_string = paramsToString(new_params)
      // special for mobile, if you click a hex set mobile_show to info
      let new_query = ownProps.query;
      if (ownProps.query.mobile_show && hex) {
        let new_query = Object.assign(ownProps.query, {mobile_show: "info"})
      }
      hashHistory.push({ pathname: new_params_string.pathname, query: new_query });
    }

    const closeHexFocus = (hex) => {
      let new_params = Object.assign(params, {hex: false});
      const new_params_string = paramsToString(new_params)
      hashHistory.push(new_params_string);
    }

    return {
      active_year,
      active_price,
      map,
      neighborhoods: new_neighborhoods,
      neighborhoods_samples,
      active_mode,
      active_probability,
      borough_filter,
      price_focus,
      probability_focus,
      active_neighborhood,
      active_neighborhood_with_samples,
      hexes: hexes,
      active_hex,
      active_hex_with_samples,
      show_roads,
      explainer,
      browser_width,
      mobile_toggle,
      changeActiveMode,
      changeActivePrice,
      changeActiveProbability,
      setBoroughFilter,
      changeActiveYear,
      setExplainer,
      setShowRoads,
      setActiveHex,
      closeHexFocus,
      mobile_show,
      changeMobileShow
    };
  },
  function mapDispatchToProps(dispatch, ownProps) {

    let params = ownProps.params;

    const paramsToString = (params) => {
      let string = '/' + params.mode + '/' + params.active_var + '/' + params.year + '/' + params.borough_filter + '/' + params.neighborhood;
      if (params.hex) string = string + '/' + params.hex;
      let param_object = { pathname: string, query: ownProps.query }
      return param_object;
    }

    return {
      setActiveNeighborhood: (neighborhood) => {
        let new_neighborhood = 'all_neighborhoods';
        if (neighborhood) new_neighborhood = neighborhood.toLowerCase().replace(/ /g,'_');
        // Always clear hex on new neighborhood
        let new_params = Object.assign(params, {neighborhood: new_neighborhood, hex: false});
        const new_params_string = paramsToString(new_params)
        hashHistory.push(new_params_string);
        // we use this action to clear hex_arrays, this is not pretty
        dispatch({
          type: 'SET_ACTIVE_NEIGHBORHOOD',
          payload: {
            neighborhood
          }
        })
      },
      closeNeighborhoodFocus: () => {
        let new_neighborhood = 'all_neighborhoods';
        // Always clear hex on new neighborhood
        let hex_end = ''
        if (params.hex) hex_end = '/' + params.hex
        hashHistory.push('/' + params.mode + '/' + params.active_var + '/' + params.year + '/' + params.borough_filter + '/' + new_neighborhood + hex_end);
        let new_params = Object.assign(params, {neighborhood: new_neighborhood, hex: false});
        const new_params_string = paramsToString(new_params)
        hashHistory.push(new_params_string);
        // we use this action to clear hex_arrays, this is not pretty
        dispatch({
          type: 'SET_ACTIVE_NEIGHBORHOOD',
          payload: {
            false
          }
        })
      },
      changePriceFocus: (price) => dispatch({
        type: 'CHANGE_PRICE_FOCUS',
        payload: {
          price
        }
      }),
      changeProbabilityFocus: (probability) => dispatch({
        type: 'CHANGE_PROBABILITY_FOCUS',
        payload: {
          probability
        }
      }),
      mapLoaded: (map) => dispatch({
        type: 'MAP_LOADED',
        payload: {
          map
        }
      }),
      getNeighborhoodsSamples: (year) => {
        dispatch({
          type: 'GET_NEIGHBORHOODS_SAMPLES',
          payload: {
            year
          }
        })
      },
      getNeighborhoodHexes: (neighborhood_name) => {
        dispatch({
          type: 'GET_NEIGHBORHOOD_HEXES',
          payload: {
            neighborhood: neighborhood_name
          }
        })
      },
      setFeatureHover: (feature) => dispatch({
        type: 'SET_FEATURE_HOVER',
        payload: {
          feature
        }
      }),
      toggleMobile: (value) => dispatch({
        type: 'TOGGLE_MOBILE',
        payload: {
          value
        }
      }),
      prospectHeights2010: () => dispatch({
        type: 'PROSPECT_HEIGHTS_2010'
      }),
      prospectHeights2016: () => dispatch({
        type: 'PROSPECT_HEIGHTS_2016'
      })
    }
  }
)(Apper);

export default ApperContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/ApperContainer.js
 **/